import { SessionServiceInterface } from "@/services/SessionService";
import { UserServiceInterface } from "@/services/UserService";

export class SyncSessionUseCase {
  constructor(
    private readonly userService: UserServiceInterface,
    private readonly sessionService: SessionServiceInterface
  ) {}

  execute = async () => {
    const session = this.sessionService.getSession();
    if (session) {
      const user = await this.userService.showUser(session.id);

      if (!user) {
        throw new Error("Erro ao atualizar sessão");
      }

      this.sessionService.saveSession(user);
    }
  };
}
